import React from 'react';
import { ButtonTracking } from 'libs/growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';
import { BlogStickyBanner } from 'libs/growth-platform-brand-system-v2/src/components/BlogStickyBanner';
import { ButtonV2 } from 'libs/growth-platform-brand-system-v2/src/components/ButtonV2';
import { textBody } from 'libs/growth-platform-brand-system-v2/src/styles/typography';
import { morphism } from 'morphism';
import { schemaDatoButton } from '../../morphismSchema/schemaDatoButton';
import { useScreenSize } from 'libs/growth-platform-brand-system-v2/src/utils/utils';

export const BlogStickyBannerComponent = ({
  stickyBanner,
  className,
  locale,
  forceTitleResponsive
}: any) => {
  const screenSize = useScreenSize();
  const tags = stickyBanner?.tags ? stickyBanner.tags : [];
  const stickyBannerCtaProps =
    stickyBanner &&
    morphism(schemaDatoButton, {
      ...stickyBanner.cta[0],
      isTitleResponsive: true,
      screenSize,
      locale,
      forceTitleResponsive
    });
  return (
    <BlogStickyBanner
      key={stickyBanner.id}
      title={stickyBanner.title}
      image={stickyBanner.image}
      className={className}
      titleClassName={textBody}
      tags={tags}
      cta={
        <ButtonTracking
          component={ButtonV2}
          labelTracking={stickyBannerCtaProps?.title}
          section="isStickyToTop_BlogStickyBanner"
          {...stickyBannerCtaProps}
        />
      }
    />
  );
};

export default BlogStickyBannerComponent;
